import { render, staticRenderFns } from "./CertificateDetail.vue?vue&type=template&id=7ef60cec&scoped=true&"
import script from "./CertificateDetail.vue?vue&type=script&lang=js&"
export * from "./CertificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDetail.vue?vue&type=style&index=0&id=7ef60cec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef60cec",
  null
  
)

export default component.exports